import { uploadFile } from '@dealstack/frontend/shared/dataExchange/services/mip.service.ts';
import { DataCustomDetailTct } from '@dealstack/shared/lib/generated';
import { useWrappedRequest } from '@dealstack/frontend/shared/other/react/ApiWrapper';
import { useCallback } from 'react';
import { useFieldArray, useFormContext } from 'react-hook-form';
import {
	FormTemplate,
	KYC_FORM_FIELDS,
	KycFormValues,
} from '@dealstack/frontend/app/pages/Project/MIP/MIPCreate/KYCRequirements/KYCDocuments/useKYCDocumentsController.ts';
import { CustomDetailEnum } from '@dealstack/shared/lib/generated/models/CustomDetailEnum.ts';

export const useFormsTemplatesListController = (type: DataCustomDetailTct['type']) => {
	const uploadFileRequest = useWrappedRequest(uploadFile);

	const mainForm = useFormContext<KycFormValues>();

	const fieldArrayName =
		type === CustomDetailEnum.INDIVIDUAL
			? KYC_FORM_FIELDS.individualFormsTemplates
			: KYC_FORM_FIELDS.pivFormsTemplates;

	const { remove, prepend } = useFieldArray({
		name: fieldArrayName,
		control: mainForm.control,
		// we use keyName to prevent override backend contract id by rhf in fields
		keyName: 'key' as 'id',
	});
	const formsTemplates = mainForm.watch(fieldArrayName);

	const addFormTemplate = useCallback((formTemplate: FormTemplate) => {
		prepend(formTemplate);
	}, []);

	const removeFormTemplate = (formTemplateIndexInFieldArray: number) => {
		remove(formTemplateIndexInFieldArray);
	};

	return {
		formsTemplates,
		uploadFileRequest,
		addFormTemplate,
		removeFormTemplate,
		fieldArrayName,
		uploadedFile: uploadFileRequest.response?.payload,
	};
};
